import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import VueCookies from 'vue-cookies';

Vue.use(VueRouter);
Vue.use(VueCookies);

const routes = [
  {
    path: '/',
    name: '',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const accessToken = Vue.$cookies.get('logged_in');
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (accessToken == null) {
      next({
        name: 'Login',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
